export default function BannerHeight(context) {
    const ratio = Math.round(1920 / 380);
    const $bannerBlur = context.querySelector('.banner__blur');
    const $banner = context.querySelector('.banner__inner');

    function setBannerHeight() {
        const height = Math.round(window.innerWidth / ratio);
        if ($banner) {
            $banner.style.height = `${height}px`;
        }

        if (window.innerWidth >= 1920 && $bannerBlur) {
            $bannerBlur.style.height = `${height}px`;
        }
    }

    setBannerHeight();
    window.addEventListener('resize', setBannerHeight);
}
